<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<v-card flat>
				<v-card-text>
					<v-form ref="form">
						<v-row dense>
							<!-- <v-col cols="12">
								<v-menu
									v-model="menu.datebegin"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
									<v-text-field v-bind="attrs" v-on="on"
										v-model="params.datebegin"
										label="Дата початку періоду"
										prepend-icon="mdi-calendar"
										readonly
										outlined
										dense
										hide-details="auto"
									></v-text-field>
									</template>
									<v-date-picker
									v-model="params.datebegin"
									@input="menu.datebegin = false"
									></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12">
								<v-menu
									v-model="menu.dateend"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
									<v-text-field v-bind="attrs" v-on="on"
										v-model="params.dateend"
										label="Дата завершення періоду"
										prepend-icon="mdi-calendar"
										readonly
										outlined
										dense
										hide-details="auto"
									></v-text-field>
									</template>
									<v-date-picker
									v-model="params.dateend"
									@input="menu.dateend = false"
									></v-date-picker>
								</v-menu>
							</v-col> -->
							<v-col cols="12">
								<v-combobox
									v-model="params.kind"
									:items="kinds"
									label="Категорія"
									outlined
									dense
									item-text="name"
									item-value="name"
									hide-details="auto"
									:loading="loading.kind"
									@change="onKind"
									@focus="loadKind"
								>
									<template v-slot:item="{ index, item }">
										<v-list-item-content>
											<v-list-item-title v-text="item.name"></v-list-item-title>
										</v-list-item-content>
										<!-- <v-list-item-action @click.stop> -->
										<v-list-item-action>
											<span class="text-caption">{{ item.cnt }}</span>
										</v-list-item-action>
									</template>
								</v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.brand"
									:items="brands"
									label="Марка"
									outlined
									dense
									item-text="name"
									item-value="name"
									hide-details="auto"
									clearable
									:loading="loading.brand"
									@change="onBrand"
									@focus="loadBrand"
								>
									<template v-slot:item="{ index, item }">
										<v-list-item-content>
											<v-list-item-title v-text="item.name"></v-list-item-title>
										</v-list-item-content>
										<v-list-item-action @click.stop>
											<span class="text-caption">{{ item.cnt }}</span>
										</v-list-item-action>
									</template>
								</v-combobox>
							</v-col>
							<v-col cols="12">
								<v-combobox
									v-model="params.model"
									:items="models"
									label="Модель"
									outlined
									dense
									item-text="name"
									item-value="name"
									hide-details="auto"
									clearable
									:loading="loading.model"
									@change="onModel"
									@focus="loadModel"
								>
									<template v-slot:item="{ index, item }">
										<v-list-item-content>
											<v-list-item-title v-text="item.name"></v-list-item-title>
										</v-list-item-content>
										<v-list-item-action @click.stop>
											<span class="text-caption">{{ item.cnt }}</span>
										</v-list-item-action>
									</template>
								</v-combobox>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<!-- PDF -->
				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->

				<!-- Excel -->
				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<download-excel 
									:data="excel.data"
									:name="excel.name"
									:type="excel.type"
								>
									<v-icon color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</download-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->
			</v-list>
        </v-navigation-drawer>

		
		<v-container style="padding: 64px 0px 0px 256px;">
			<v-breadcrumbs :items="crumbs" divider="-" ></v-breadcrumbs>
		
			<v-card flat>
				<v-card-title class="font-weight-light">
					{{ title }}
				</v-card-title>

				<v-divider></v-divider>

				<!-- <v-data-table v-if="data.datasets.ds.length" -->
				<v-data-table
					:headers="headers"
					:items="items"
					hide-default-footer
					disable-pagination
					:loading="loading.table"
				>
					<template #item.percentage="{ item }">
						{{ calculatePercentage(item.cnt, total) }}
					</template>
				</v-data-table>
				<!-- :items="data.datasets.ds" -->
			</v-card>
		</v-container>
		<!-- <v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay> -->
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<!-- <z-pdf ref="pdf" :code="code" :name="name"></z-pdf> -->
	</v-main>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import mixin from './mixin/main'
// import downloadExcel from "vue-json-excel"

export default {
	mixins: [mixin],
	components: { },
	data: () => ({
		headers: [
			{ text: 'Регіон', value: 'regionName' },
			{ text: 'Категорія', value: 'kindName' },
			{ text: 'Марка', value: 'brandName' },
			{ text: 'Модель', value: 'modelName' },
			{ text: 'Кількість', value: 'cnt' },
			{ text: '%', value: 'percentage', sortable: false },
		],

		kinds: [],
		brands: [],
		models: [],
		//regions: [],
		//cities: [],

		loading: {
			kind: false,
			brand: false,
			model: false,
			//region: false,
			//city: false,
			table: false,
		},
	}),

	props: {
		code: 				{ type: String, default: 'VehicleReestrRegion' },
		name: 				{ type: String, default: 'Статистика по регіонам на основі реєстру транспортних засобів' },
		datebegin: 			{ type: [Date, String] },
		dateend: 			{ type: [Date, String] },
	},

	computed: {
		...mapGetters('ReportVehicleReestrRegion', [ 'items' ] ),

		total() {
			const total = this.items.reduce((sum, item) => sum + parseInt(item.cnt), 0);
			return total
		}
	},

	methods: {
		...mapActions('ReportVehicleReestrRegion', [ 'setItems' ]),

		//-------------------------------------------------
		clearKind () {
			this.kinds = []
			this.clearBrand()
		},

		onKind (item) {
			this.params.brand = null
			this.params.model = null
			this.loadBrand()
		},

		loadKind(e) {
			let that = this

			if(this.kinds.length == 0) {
				this.loading.kind = true
				axios.get(`/vehicle/reestr/kinds`).then(response => {
					that.kinds = response.data
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.kind = false));
			}
		},

		//-------------------------------------------------
		clearBrand () {
			this.brands = []
			this.params.brand = null
			this.clearModel()
		},

		onBrand (item) {
			this.params.model = null
			this.loadModel()
		},

		loadBrand(e) {
			let that = this
			//console.log('loadBrand', this.params)
			if(this.params?.kind?.name) {
				this.loading.brand = true
				axios.get(`/vehicle/reestr/kind/${this.params.kind.name}/brends`).then(response => {
					that.brands = response.data
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.brand = false));
			}
		},

		//-------------------------------------------------
		clearModel () {
			this.models = []
			this.params.model = null
		},

		onModel (item) {
			//this.$set(this.params, 'model', null)
			//this.loadBrand()
		},

		loadModel(e) {
			let that = this
			if(this.params?.kind?.name && this.params?.brand?.name) {
				this.loading.model = true
				axios.get(`/vehicle/reestr/kind/${this.params.kind.name}/brend/${this.params.brand.name}/models`).then(response => {
					that.models = response.data
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.model = false));
			}
		},

		//-------------------------------------------------

		onOK() {
			let that = this


			/* case 'KindBrend': 
				$item = $em->getRepository($this->getEntity())->StatisticKindBrend($kindName, $brandName);
				break;
			case 'KindBrendModel': */ 

			//if(this.params?.brand?.name) this.params.mode = 'KindBrendModel'

			this.params.mode = this.params?.model?.name ? 'KindBrendModel' : 'KindBrend'


			if (this.$refs.form.validate()) {
				//console.log(this.$options.name, 'params', this.params)

				this.loading.table = true
				axios.post(`vehicle/reestr/statistic`, this.params).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					that.setItems(response.data)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading.table = false
				});
			}
		},

		calculatePercentage(value, total) {
			if (!total || total === 0) return 0;
			return ((value / total) * 100).toFixed(2); // Returns value with 2 decimals
		},
	},
}
</script>